import { useTheme } from '@/contexts/ThemeContext';
import { Icon, type IconName } from './Icon';

const ICON: Record<'light' | 'dark' | 'system', IconName> = {
  light: 'sun',
  dark: 'moon',
  // For 'system' we reuse the sun icon — distinguishing system vs explicit
  // light only matters in the underlying state, not the button face. The
  // title tooltip makes the current mode explicit.
  system: 'sun',
};

const NEXT: Record<'light' | 'dark' | 'system', 'light' | 'dark' | 'system'> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(NEXT[theme])}
      title={`Theme: ${theme} (click to cycle)`}
      aria-label={`Switch theme (currently ${theme})`}
    >
      <Icon name={ICON[theme]} size={16} />
    </button>
  );
}
